import React from 'react';
import KYC from '../components/KYC';

export default function KYCPage() {
	return <KYC />;
}
